import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams, useLocation } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Nav, NavItem, NavLink, Pagination, PaginationItem, PaginationLink, Progress, Row, TabContent, Table, TabPane, UncontrolledCollapse, UncontrolledDropdown } from 'reactstrap';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from "swiper/react";
import  { Autoplay } from "swiper/modules";
import SwiperCore from "swiper";
import TimeOffCalendar from '../Authentication/Profile/TimeOffCalendar';

//Images
import profileBg from '../../assets/images/auth-one-bg.jpg'; 
import avatar2 from '../../assets/images/users/avatar-2.jpg'; 

import { ToastContainer, toast } from 'react-toastify';
import { projects, document } from '../../common/data';

//fetch profile function
import { getUserDetails, baseURL } from '../../utils/usermanagement';
import { fetchActivities } from '../../utils/message';


const EmployeeDetail = () => { 
    const getCurrentUser = () => {
        const userData = sessionStorage.getItem("user");
        return userData ? JSON.parse(userData) : null;
    }; 
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activities, setActivities] = useState([]);

    SwiperCore.use([Autoplay]);

    const [activeTab, setActiveTab] = useState('1');
    const [activityTab, setActivityTab] = useState('1');
    const [profileImageUrl, setProfileImageUrl] = useState(""); // Store uploaded profile image URL
    const [avatarUrl, setAvatarUrl] = useState(null); // Store uploaded avatar URL
    const location = useLocation(); // Get current location
    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get("userId"); // Extract productId from query params
    
    
    useEffect(() => {
        const handleReload = () => {  
            loadProfileData(userId);
            loadActivitiesData();
        };
        
        // 立即执行一次数据加载
        handleReload();
        
        window.addEventListener('reloadProfile', handleReload);
        return () => window.removeEventListener('reloadProfile', handleReload);
    }, []);  // 确保空依赖数组只执行一次

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const toggleActivityTab = (tab) => {
        if (activityTab !== tab) {
            setActivityTab(tab);
        }
    };
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });

    
      const loadProfileData = async (id) => {
        try { 
          const response = await getUserDetails(id);
          if(response.status==200){  
              setProfileData(response.data.data); 
              if(response.data.data.profile_photo_url_object.profile_url){
                setAvatarUrl( `${baseURL}/file/avatar/${response.data.data.profile_photo_url_object.profile_url}`); 
              }
               
            setProfileImageUrl(response.data.data.profileImage?`${baseURL}/file/profile/image/${response.data.data.profileImage}`:`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`)
            }else {
              errornotify(response.message)  
            }
          } catch (error) {
              errornotify(error.message) 
        } finally {
          setLoading(false);
        }
      };
      const loadActivitiesData = async (id) => {
        try {
          const response = await fetchActivities(id);
          if(response.status==200){
              setActivities(response.data);
            }else {
              errornotify(response.message)
            }
          } catch (error) {
              errornotify(error.message)         
          }
     };
      
      if (loading) {
        return <div>Loading...</div>;
      }
    
      if (!profileData) {
        return <div>Error loading profile data</div>;
      }
    // 在组件内添加过滤方法
    const filterActivities = (activity,timeRange) => {
        const now = new Date();
        const activityDate = new Date(activity.timestamp); // 现在能正确获取活动时间
        
        switch(timeRange) {
        case '1': // 当天
            const startOfDay = new Date(now.setHours(0,0,0,0));
            const endOfDay = new Date(now.setHours(23,59,59,999));
            return activityDate >= startOfDay && activityDate <= endOfDay;
            
        case '2': // 近一周
            const oneWeekAgo = new Date(now - 7 * 24 * 60 * 60 * 1000);
            return activityDate >= oneWeekAgo;
            
        case '3': // 近一月  
            const oneMonthAgo = new Date(now);
            oneMonthAgo.setMonth(now.getMonth() - 1);
            return activityDate >= oneMonthAgo;
            
        default:
            return true;
        }
    };

    document.title = "Employee Detail | SeedNations";
    return (
        <React.Fragment>
            <div className="page-content"> 
                <Container fluid>   
                <ToastContainer />
                    <div className="profile-foreground position-relative mx-n4 mt-n4">
                        <div className="profile-wid-bg">
                            <img src={profileBg} alt="" className="profile-wid-img" />
                        </div>
                    </div>
                    <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
                        <Row className="g-4">
                        <Link to="/employees" className="d-inline-block flex-grow-1 ms-2 mb-3 text-decoration-none text-white"> 
                            <i className="ri-arrow-left-line align-middle"></i> Employees
                        </Link>
                            <div className="col-auto">
                                <div className="avatar-lg">
                                    <img src={avatarUrl?avatarUrl:profileImageUrl} alt="user-img"
                                        className=" rounded-circle" height="100" width="100"/>
                                </div>
                            </div>

                            <Col>
                                <div className="p-2">
                                    <h3 className="text-white mb-1">{profileData.first_name}{profileData.last_name}</h3>
                                    <p className="text-white text-opacity-75">{profileData.role}</p>
                                     <div className="hstack text-white-50 gap-1">
                                        <div className="me-2"><i
                                            className="ri-map-pin-user-line me-1 text-white text-opacity-75 fs-16 align-middle"></i>{profileData.city}, {profileData.state}</div>
                                        <div><i
                                            className="ri-building-line me-1 text-white text-opacity-75 fs-16 align-middle"></i>{profileData.company.oem_companyname}
                                        </div>
                                    </div> 
                                </div>
                            </Col> 
                        </Row>
                    </div>

                    <Row>
                        <Col lg={12}>
                            <div>
                                <div className="d-flex">
                                    <Nav pills className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                                        role="tablist">
                                        <NavItem>
                                            <NavLink
                                                href="#overview-tab"
                                                className={classnames({ active: activeTab === '1' })}
                                                onClick={() => { toggleTab('1'); }}
                                            >
                                                <i className="ri-airplay-fill d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Overview</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                href="#activities"
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => { toggleTab('2'); }}
                                            >
                                                <i className="ri-list-unordered d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Activities</span>
                                            </NavLink>
                                        </NavItem> 
                                        <NavItem>
                                            <NavLink
                                                href="#documents"
                                                className={classnames({ active: activeTab === '3' })}
                                                onClick={() => { toggleTab('3'); }}
                                            >
                                                <i className="ri-folder-4-line d-inline-block d-md-none"></i> <span
                                                    className="d-none d-md-inline-block">Time off</span>
                                            </NavLink>
                                        </NavItem>
                                    </Nav> 
                                </div>

                                <TabContent activeTab={activeTab} className="pt-4">
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col xxl={3}> 

                                                <Card>
                                                    <CardBody>
                                                        <h5 className="card-title mb-3">Info</h5>
                                                        <div className="table-responsive">
                                                            <Table className="table-borderless mb-0">
                                                                <tbody>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Full Name :</th>
                                                                        <td className="text-muted">{profileData.first_name}{profileData.last_name}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Mobile :</th>
                                                                        <td className="text-muted">{profileData.mobile}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">E-mail :</th>
                                                                        <td className="text-muted">{profileData.email}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Location :</th>
                                                                        <td className="text-muted">{profileData.city},{profileData.state}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Joining Date</th>
                                                                        <td className="text-muted">24 Nov 2021</td>
                                                                    </tr>  
                                                                    <tr>
                                                                            <th className="ps-0" scope="row">Position</th>
                                                                            <td className="text-muted">{profileData.position}</td>
                                                                        </tr><tr>
                                                                                <th className="ps-0" scope="row">Department</th>
                                                                                <td className="text-muted">{profileData.department || ""}</td>
                                                                            </tr><tr>
                                                                                <th className="ps-0" scope="row">Manager</th>
                                                                                <td className="text-muted">{profileData.manager || ""}</td>
                                                                            </tr><tr>
                                                                                <th className="ps-0" scope="row">Company</th>
                                                                                <td className="text-muted">{profileData.company.oem_companyname || ""}</td>
                                                                            </tr><tr>
                                                                                <th className="ps-0" scope="row">Address</th>
                                                                                <td className="text-muted">{profileData.address || ""}</td>
                                                                            </tr> 
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </CardBody>
                                                </Card> 
                                            </Col>
                                            <Col xxl={9}>
                                                <Card>
                                                    <CardBody>
                                                        <h5 className="card-title mb-3">About</h5>
                                                        {profileData.about}
                                                        
                                                    </CardBody>
                                                </Card>

                                                <Row>
                                                    <Col lg={12}>
                                                        <Card>
                                                            <CardHeader className="align-items-center d-flex">
                                                                <h4 className="card-title mb-0  me-2">Recent Activity</h4>
                                                                <div className="flex-shrink-0 ms-auto">
                                                                    <Nav className="justify-content-end nav-tabs-custom rounded card-header-tabs border-bottom-0"
                                                                        role="tablist">
                                                                        <NavItem>
                                                                            <NavLink
                                                                                href="#"
                                                                                className={classnames({ active: activityTab === '1' })}
                                                                                onClick={() => { toggleActivityTab('1'); }}
                                                                            >
                                                                                Today
                                                                            </NavLink>
                                                                        </NavItem>
                                                                        <NavItem>
                                                                            <NavLink
                                                                                href="#"
                                                                                className={classnames({ active: activityTab === '2' })}
                                                                                onClick={() => { toggleActivityTab('2'); }}
                                                                            >
                                                                                Weekly
                                                                            </NavLink>
                                                                        </NavItem>
                                                                        <NavItem className="nav-item">
                                                                            <NavLink
                                                                                href="#"
                                                                                className={classnames({ active: activityTab === '3' })}
                                                                                onClick={() => { toggleActivityTab('3'); }}
                                                                            >
                                                                                Monthly
                                                                            </NavLink>
                                                                        </NavItem>
                                                                    </Nav>
                                                                </div>
                                                            </CardHeader>
                                                            <CardBody>
                                                                <TabContent activeTab={activityTab} className="text-muted">
                                                                    <TabPane tabId="1">
                                                                        <div className="profile-timeline"> 
                                                                            {activities?activities
                                                                                .filter(activity => filterActivities(activity,'1'))
                                                                                .map(activity => (
                                                                                <div className="accordion-item border-0">
                                                                                    <div className="accordion-header"
                                                                                        id="heading12">
                                                                                        <Link to="#" className="accordion-button p-2 shadow-none"
                                                                                            id="collapse12"
                                                                                            aria-expanded="true">
                                                                                            <div className="d-flex">
                                                                                                <div
                                                                                                    className="flex-shrink-0">
                                                                                                    <img src={activity.profile_picture_url?`${baseURL}/file/profile/image/${activity.profile_picture_url}`:`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`}
                                                                                                        alt=""
                                                                                                        className="avatar-xs rounded-circle" />
                                                                                                </div>
                                                                                                <div
                                                                                                    className="flex-grow-1 ms-3">
                                                                                                    <h6
                                                                                                        className="fs-14 mb-1">
                                                                                                        {activity.name}
                                                                                                    </h6>
                                                                                                    <small
                                                                                                        className="text-muted">{activity.timestamp}</small>
                                                                                                </div>
                                                                                            </div>
                                                                                        </Link>
                                                                                    </div>
                                                                                    <UncontrolledCollapse toggler="collapse12" className="accordion-collapse collapse" defaultOpen>
                                                                                        <div
                                                                                            className="accordion-body ms-2 ps-5">
                                                                                            {activity.action} - {activity.details}
                                                                                        </div>
                                                                                    </UncontrolledCollapse>
                                                                                </div>  
                                                                            )):""}  

                                                                        </div>
                                                                    </TabPane>
                                                                    <TabPane tabId="2">
                                                                        <div className="profile-timeline">
                                                                            <div className="accordion accordion-flush"
                                                                                id="weeklyExample">
                                                                                {activities?activities
                                                                                .filter(activity => filterActivities(activity,'2'))
                                                                                .map(activity => (
                                                                                <div className="accordion-item border-0">
                                                                                    <div className="accordion-header"
                                                                                        id="heading12">
                                                                                        <Link to="#" className="accordion-button p-2 shadow-none"
                                                                                            id="collapse12"
                                                                                            aria-expanded="true">
                                                                                            <div className="d-flex">
                                                                                                <div
                                                                                                    className="flex-shrink-0">
                                                                                                    <img src={activity.profile_picture_url?`${baseURL}/file/profile/image/${activity.profile_picture_url}`:`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`}
                                                                                                        alt=""
                                                                                                        className="avatar-xs rounded-circle" />
                                                                                                </div>
                                                                                                <div
                                                                                                    className="flex-grow-1 ms-3">
                                                                                                    <h6
                                                                                                        className="fs-14 mb-1">
                                                                                                        {activity.name}
                                                                                                    </h6>
                                                                                                    <small
                                                                                                        className="text-muted">{activity.timestamp}</small>
                                                                                                </div>
                                                                                            </div>
                                                                                        </Link>
                                                                                    </div>
                                                                                    <UncontrolledCollapse toggler="collapse12" className="accordion-collapse collapse" defaultOpen>
                                                                                        <div
                                                                                            className="accordion-body ms-2 ps-5">
                                                                                            {activity.action} - {activity.details}
                                                                                        </div>
                                                                                    </UncontrolledCollapse>
                                                                                </div>  
                                                                            )):""}  
                                                                            </div>  
                                                                        </div>
                                                                    </TabPane>
                                                                    <TabPane tabId="3">
                                                                        <div className="profile-timeline">
                                                                            <div className="accordion accordion-flush"
                                                                                id="monthlyExample">
                                                                                
                                                                                {activities?activities
                                                                                        .filter(activity => filterActivities(activity,'3'))
                                                                                        .map(activity => (
                                                                                        <div className="accordion-item border-0">
                                                                                            <div className="accordion-header"
                                                                                                id="heading12">
                                                                                                <Link to="#" className="accordion-button p-2 shadow-none"
                                                                                                    id="collapse12"
                                                                                                    aria-expanded="true">
                                                                                                    <div className="d-flex">
                                                                                                        <div
                                                                                                            className="flex-shrink-0">
                                                                                                            <img src={activity.profile_picture_url?`${baseURL}/file/profile/image/${activity.profile_picture_url}`:`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`}
                                                                                                                alt=""
                                                                                                                className="avatar-xs rounded-circle" />
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="flex-grow-1 ms-3">
                                                                                                            <h6
                                                                                                                className="fs-14 mb-1">
                                                                                                                {activity.action}
                                                                                                            </h6>
                                                                                                            <small
                                                                                                                className="text-muted">{activity.timestamp}</small>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </Link>
                                                                                            </div>
                                                                                            <UncontrolledCollapse toggler="collapse12" className="accordion-collapse collapse" defaultOpen>
                                                                                                <div
                                                                                                    className="accordion-body ms-2 ps-5">
                                                                                                    {activity.details}
                                                                                                </div>
                                                                                            </UncontrolledCollapse>
                                                                                        </div>  
                                                                                )):""} 
                                                                            </div>
                                                                        </div>
                                                                    </TabPane>

                                                                </TabContent>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
 
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Card>
                                            <CardBody>
                                                <h5 className="card-title mb-3">Activities</h5>
                                                <div className="Activity-timeline">
                                                    {activities?activities.map(activity => ( 
                                                    <div className="Activity-item py-3 d-flex">
                                                          <div className="flex-shrink-0">
                                                              <img src={activity.profile_picture_url?`${baseURL}/file/profile/image/${activity.profile_picture_url}`:avatar2} alt="" className="avatar-xs rounded-circle Activity-avatar" />
                                                          </div>
                                                          <div className="flex-grow-1 ms-3">
                                                              <h6 className="mb-1">{activity.name} <span
                                                                  className="badge bg-primary-subtle text-primary align-middle">{activity.module}</span>
                                                              </h6>
                                                              <p className="text-muted mb-2"> {activity.action} -{activity.details}</p>
                                                              <small className="mb-0 text-muted">{activity.timestamp}</small>
                                                          </div>
                                                      </div>
                                                    )):""} 
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </TabPane>  
                                    <TabPane tabId="3">
                                        <TimeOffCalendar/>
                                    </TabPane>
                                </TabContent>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default EmployeeDetail;